import { SvgIcon } from '@mui/material';
import { ReactComponent as ArrowDownBold } from './bold/arrow-down.svg';
import { ReactComponent as ArrowLeftBold } from './bold/arrow-left.svg';
import { ReactComponent as ArrowRightBold } from './bold/arrow-right.svg';
import { ReactComponent as ArrowUpBold } from './bold/arrow-up.svg';
import { ReactComponent as CloseCircleBold } from './bold/close-circle.svg';
import { ReactComponent as SettingBold } from './bold/setting.svg';
import { ReactComponent as AddCircleLinear } from './linear/add-circle.svg';
import { ReactComponent as AddCircleWhiteLinear } from './linear/add-circle-white.svg';
import { ReactComponent as AddLinear } from './linear/add.svg';
import { ReactComponent as ArchiveCustomLinear } from './linear/archive-custom.svg';
import { ReactComponent as ArchiveLinear } from './linear/archive.svg';
import { ReactComponent as ArrangeSquare2Linear } from './linear/arrange-square-2.svg';
import { ReactComponent as ArrowDown1Linear } from './linear/arrow-down-1.svg';
import { ReactComponent as ArrowDownLinear } from './linear/arrow-down.svg';
import { ReactComponent as ArrowLeftLinear } from './linear/arrow-left.svg';
import { ReactComponent as ArrowRight1Linear } from './linear/arrow-right-1.svg';
import { ReactComponent as ArrowRight1LightLinear } from './linear/arrow-right-1-light.svg';
import { ReactComponent as ArrowRightLinear } from './linear/arrow-right.svg';
import { ReactComponent as ArrowUp1Linear } from './linear/arrow-up-1.svg';
import { ReactComponent as ArrowUpLinear } from './linear/arrow-up.svg';
import { ReactComponent as BagLinear } from './linear/bag.svg';
import { ReactComponent as Blend2Linear } from './linear/blend-2.svg';
import { ReactComponent as BubbleLinear } from './linear/bubble.svg';
import { ReactComponent as CalendarLinear } from './linear/calendar.svg';
import { ReactComponent as Candle2Linear } from './linear/candle-2.svg';
import { ReactComponent as CdLinear } from './linear/cd.svg';
import { ReactComponent as CelsiuscelLinear } from './linear/celsius-(cel)-.svg';
import { ReactComponent as CloseCircleCustomLinear } from './linear/close-circle-custom.svg';
import { ReactComponent as CloseCircleCustom2Linear } from './linear/close-circle-custom2.svg';
import { ReactComponent as CloseCircleLinear } from './linear/close-circle.svg';
import { ReactComponent as Coin1Linear } from './linear/coin-1.svg';
import { ReactComponent as CoinLinear } from './linear/coin.svg';
import { ReactComponent as ConvertLinear } from './linear/convert.svg';
import { ReactComponent as DiscountCircleLinear } from './linear/discount-circle.svg';
import { ReactComponent as DocumentDownloadLinear } from './linear/document-download.svg';
import { ReactComponent as DocumentTextLinear } from './linear/document-text.svg';
import { ReactComponent as DollarCircleLinear } from './linear/dollar-circle.svg';
import { ReactComponent as DriverLinear } from './linear/driver.svg';
import { ReactComponent as Edit1Linear } from './linear/edit-1.svg';
import { ReactComponent as EditLinear } from './linear/edit.svg';
import { ReactComponent as EmptyWalletLinear } from './linear/empty-wallet.svg';
import { ReactComponent as EnterBadgeLinear } from './linear/enter-badge.svg';
import { ReactComponent as FlashCircleLinear } from './linear/flash-circle.svg';
import { ReactComponent as GalleryLinear } from './linear/gallery.svg';
import { ReactComponent as Grid2Linear } from './linear/grid-2.svg';
import { ReactComponent as Grid7Linear } from './linear/grid-7.svg';
import { ReactComponent as GroupLinear } from './linear/group.svg';
import { ReactComponent as HomeLinear } from './linear/home.svg';
import { ReactComponent as HomeTranspBulk } from './bulk/home-transp.svg';
import { ReactComponent as KeySquareLinear } from './linear/key-square.svg';
import { ReactComponent as KeyLinear } from './linear/key.svg';
import { ReactComponent as LevelLinear } from './linear/level.svg';
import { ReactComponent as LinkLinear } from './linear/link.svg';
import { ReactComponent as LocationLinear } from './linear/location.svg';
import { ReactComponent as LogoutRotatedLinear } from './linear/logout-rotated.svg';
import { ReactComponent as LogoutLinear } from './linear/logout.svg';
import { ReactComponent as MessageQuestionCustomLinear } from './linear/message-question-custom.svg';
import { ReactComponent as MessageQuestionLinear } from './linear/message-question.svg';
import { ReactComponent as MessagesLinear } from './linear/messages.svg';
import { ReactComponent as MinusSquareCustom1Linear } from './linear/minus-square-custom-1.svg';
import { ReactComponent as MinusSquareCustomLinear } from './linear/minus-square-custom.svg';
import { ReactComponent as MinusSquareLinear } from './linear/minus-square.svg';
import { ReactComponent as MinusLinear } from './linear/minus.svg';
import { ReactComponent as MobileCustonLinear } from './linear/mobile-custon.svg';
import { ReactComponent as MobileLinear } from './linear/mobile.svg';
import { ReactComponent as Money3Linear } from './linear/money-3.svg';
import { ReactComponent as MoneysLinear } from './linear/moneys.svg';
import { ReactComponent as MonitorMobbileLinear } from './linear/monitor-mobbile.svg';
import { ReactComponent as NotificationStatusLinear } from './linear/notification-status.svg';
import { ReactComponent as PersonalcardLinear } from './linear/personalcard.svg';
import { ReactComponent as Profile2userLinear } from './linear/profile-2user.svg';
import { ReactComponent as ProfileCircleLinear } from './linear/profile-circle.svg';
import { ReactComponent as Receipt2Linear } from './linear/receipt-2.svg';
import { ReactComponent as ReceiptLinear } from './linear/receipt.svg';
import { ReactComponent as ReceiveSquare2Linear } from './linear/receive-square-2.svg';
import { ReactComponent as ReceivedLinear } from './linear/received.svg';
import { ReactComponent as ReviewCustomLinear } from './linear/review-custom.svg';
import { ReactComponent as ScanBarcodeLinear } from './linear/scan-barcode.svg';
import { ReactComponent as SearchNormal1Linear } from './linear/search-normal-1.svg';
import { ReactComponent as SearchNormalLinear } from './linear/search-normal.svg';
import { ReactComponent as SendSqaure2Linear } from './linear/send-sqaure-2.svg';
import { ReactComponent as SendLinear } from './linear/send.svg';
import { ReactComponent as Setting4Linear } from './linear/setting-4.svg';
import { ReactComponent as ShopLinear } from './linear/shop.svg';
import { ReactComponent as SliderHorizontal1Linear } from './linear/slider-horizontal-1.svg';
import { ReactComponent as SliderHorizontalLinear } from './linear/slider-horizontal.svg';
import { ReactComponent as SortLinear } from './linear/sort.svg';
import { ReactComponent as StacksstxLinear } from './linear/stacks-(stx).svg';
import { ReactComponent as StoryLinear } from './linear/story.svg';
import { ReactComponent as TickSquareCustomLinear } from './linear/tick-square-custom.svg';
import { ReactComponent as TickSquareLinear } from './linear/tick-square.svg';
import { ReactComponent as TimerLinear } from './linear/timer.svg';
import { ReactComponent as TrashLinear } from './linear/trash.svg';
import { ReactComponent as TrashErrorLinear } from './linear/trash-error.svg';
import { ReactComponent as UserOctagonLinear } from './linear/user-octagon.svg';
import { ReactComponent as UserTagLinear } from './linear/user-tag.svg';
import { ReactComponent as CloseCircleVioletLinear } from './linear/close-circle-violet.svg';
import { ReactComponent as EmptyWalletBulk } from './bulk/empty-wallet.svg';
import { ReactComponent as EmptyWalletTransparentBulk } from './bulk/empty-wallet-transparent.svg';
import { ReactComponent as ProfileCircleTransparentBulk } from './bulk/profile-circle-transparent.svg';
import { ReactComponent as HomeBulk } from './bulk/home.svg';
import { ReactComponent as DirectInboxLinear } from './linear/direct-inbox.svg';
import { ReactComponent as EmojiHappyLinear } from './linear/emoji-happy.svg';
import { ReactComponent as GrammerlyCustomLinear } from './linear/grammerly-custom.svg';
import { ReactComponent as PharagraphspacingLinear } from './linear/pharagraphspacing.svg';
import { ReactComponent as SmallcapsLinear } from './linear/smallcaps.svg';
import { ReactComponent as TextLinear } from './linear/text.svg';
import { ReactComponent as TextBoldLinear } from './linear/text-bold.svg';
import { ReactComponent as TextItalicLinear } from './linear/text-italic.svg';
import { ReactComponent as TextUnderlineLinear } from './linear/text-underline.svg';

export const TextUnderlineLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TextUnderlineLinear />
    </SvgIcon>
);

export const TextItalicLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TextItalicLinear />
    </SvgIcon>
);

export const TextBoldLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TextBoldLinear />
    </SvgIcon>
);

export const TextLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TextLinear />
    </SvgIcon>
);

export const SmallcapsLinearIcon = (props) => (
    <SvgIcon {...props}>
        <SmallcapsLinear />
    </SvgIcon>
);

export const PharagraphspacingLinearIcon = (props) => (
    <SvgIcon {...props}>
        <PharagraphspacingLinear />
    </SvgIcon>
);

export const GrammerlyCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <GrammerlyCustomLinear />
    </SvgIcon>
);

export const EmojiHappyLinearIcon = (props) => (
    <SvgIcon {...props}>
        <EmojiHappyLinear />
    </SvgIcon>
);

export const DirectInboxLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DirectInboxLinear />
    </SvgIcon>
);

export const ArrowDownBoldIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowDownBold />
    </SvgIcon>
);

export const ArrowLeftBoldIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowLeftBold />
    </SvgIcon>
);

export const ArrowRightBoldIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowRightBold />
    </SvgIcon>
);

export const ArrowUpBoldIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowUpBold />
    </SvgIcon>
);

export const CloseCircleBoldIcon = (props) => (
    <SvgIcon {...props}>
        <CloseCircleBold />
    </SvgIcon>
);

export const SettingBoldIcon = (props) => (
    <SvgIcon {...props}>
        <SettingBold />
    </SvgIcon>
);

export const AddCircleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <AddCircleLinear />
    </SvgIcon>
);
export const AddCircleWhiteLinearIcon = (props) => (
    <SvgIcon {...props}>
        <AddCircleWhiteLinear />
    </SvgIcon>
);

export const AddLinearIcon = (props) => (
    <SvgIcon {...props}>
        <AddLinear />
    </SvgIcon>
);

export const ArchiveCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArchiveCustomLinear />
    </SvgIcon>
);

export const ArchiveLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArchiveLinear />
    </SvgIcon>
);

export const ArrangeSquare2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrangeSquare2Linear />
    </SvgIcon>
);

export const ArrowDown1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowDown1Linear />
    </SvgIcon>
);

export const ArrowDownLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowDownLinear />
    </SvgIcon>
);

export const ArrowLeftLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowLeftLinear />
    </SvgIcon>
);

export const ArrowRight1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowRight1Linear />
    </SvgIcon>
);

export const ArrowRight1LightLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowRight1LightLinear />
    </SvgIcon>
);

export const ArrowRightLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowRightLinear />
    </SvgIcon>
);

export const ArrowUp1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowUp1Linear />
    </SvgIcon>
);

export const ArrowUpLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ArrowUpLinear />
    </SvgIcon>
);

export const BagLinearIcon = (props) => (
    <SvgIcon {...props}>
        <BagLinear />
    </SvgIcon>
);

export const Blend2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Blend2Linear />
    </SvgIcon>
);

export const BubbleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <BubbleLinear />
    </SvgIcon>
);

export const CalendarLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CalendarLinear />
    </SvgIcon>
);

export const Candle2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Candle2Linear />
    </SvgIcon>
);

export const CdLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CdLinear />
    </SvgIcon>
);

export const CelsiuscelLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CelsiuscelLinear />
    </SvgIcon>
);

export const CloseCircleCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CloseCircleCustomLinear />
    </SvgIcon>
);

export const HistoryLogCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DocumentTextLinear />
    </SvgIcon>
);

export const CloseCircleVioletLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CloseCircleVioletLinear />
    </SvgIcon>
);

export const CloseCircleCustom2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <CloseCircleCustom2Linear />
    </SvgIcon>
);

export const CloseCircleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CloseCircleLinear />
    </SvgIcon>
);

export const Coin1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Coin1Linear />
    </SvgIcon>
);

export const CoinLinearIcon = (props) => (
    <SvgIcon {...props}>
        <CoinLinear />
    </SvgIcon>
);

export const ConvertLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ConvertLinear />
    </SvgIcon>
);

export const DiscountCircleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DiscountCircleLinear />
    </SvgIcon>
);

export const DocumentDownloadLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DocumentDownloadLinear />
    </SvgIcon>
);

export const DocumentTextLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DocumentTextLinear />
    </SvgIcon>
);

export const DollarCircleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DollarCircleLinear />
    </SvgIcon>
);

export const DriverLinearIcon = (props) => (
    <SvgIcon {...props}>
        <DriverLinear />
    </SvgIcon>
);

export const Edit1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Edit1Linear />
    </SvgIcon>
);

export const EditLinearIcon = (props) => (
    <SvgIcon {...props}>
        <EditLinear />
    </SvgIcon>
);

export const EmptyWalletLinearIcon = (props) => (
    <SvgIcon {...props}>
        <EmptyWalletLinear />
    </SvgIcon>
);

export const EnterBadgeLinearIcon = (props) => (
    <SvgIcon {...props}>
        <EnterBadgeLinear />
    </SvgIcon>
);

export const FlashCircleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <FlashCircleLinear />
    </SvgIcon>
);

export const GalleryLinearIcon = (props) => (
    <SvgIcon {...props}>
        <GalleryLinear />
    </SvgIcon>
);

export const Grid2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Grid2Linear />
    </SvgIcon>
);

export const Grid7LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Grid7Linear />
    </SvgIcon>
);

export const GroupLinearIcon = (props) => (
    <SvgIcon {...props}>
        <GroupLinear />
    </SvgIcon>
);

export const HomeLinearIcon = (props) => (
    <SvgIcon {...props}>
        <HomeLinear />
    </SvgIcon>
);

export const KeySquareLinearIcon = (props) => (
    <SvgIcon {...props}>
        <KeySquareLinear />
    </SvgIcon>
);

export const KeyLinearIcon = (props) => (
    <SvgIcon {...props}>
        <KeyLinear />
    </SvgIcon>
);

export const LevelLinearIcon = (props) => (
    <SvgIcon {...props}>
        <LevelLinear />
    </SvgIcon>
);

export const LinkLinearIcon = (props) => (
    <SvgIcon {...props}>
        <LinkLinear />
    </SvgIcon>
);

export const LocationLinearIcon = (props) => (
    <SvgIcon {...props}>
        <LocationLinear />
    </SvgIcon>
);

export const LogoutRotatedLinearIcon = (props) => (
    <SvgIcon {...props}>
        <LogoutRotatedLinear />
    </SvgIcon>
);

export const LogoutLinearIcon = (props) => (
    <SvgIcon {...props}>
        <LogoutLinear />
    </SvgIcon>
);

export const MessageQuestionCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MessageQuestionCustomLinear />
    </SvgIcon>
);

export const MessageQuestionLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MessageQuestionLinear />
    </SvgIcon>
);

export const MessagesLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MessagesLinear />
    </SvgIcon>
);

export const MinusSquareCustom1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <MinusSquareCustom1Linear />
    </SvgIcon>
);

export const MinusSquareCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MinusSquareCustomLinear />
    </SvgIcon>
);

export const MinusSquareLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MinusSquareLinear />
    </SvgIcon>
);

export const MinusLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MinusLinear />
    </SvgIcon>
);

export const MobileCustonLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MobileCustonLinear />
    </SvgIcon>
);

export const MobileLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MobileLinear />
    </SvgIcon>
);

export const Money3LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Money3Linear />
    </SvgIcon>
);

export const MoneysLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MoneysLinear />
    </SvgIcon>
);

export const MonitorMobbileLinearIcon = (props) => (
    <SvgIcon {...props}>
        <MonitorMobbileLinear />
    </SvgIcon>
);

export const NotificationStatusLinearIcon = (props) => (
    <SvgIcon {...props}>
        <NotificationStatusLinear />
    </SvgIcon>
);

export const PersonalcardLinearIcon = (props) => (
    <SvgIcon {...props}>
        <PersonalcardLinear />
    </SvgIcon>
);

export const Profile2userLinearIcon = (props) => (
    <SvgIcon {...props}>
        <Profile2userLinear />
    </SvgIcon>
);

export const ProfileCircleLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ProfileCircleLinear />
    </SvgIcon>
);

export const Receipt2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Receipt2Linear />
    </SvgIcon>
);

export const ReceiptLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ReceiptLinear />
    </SvgIcon>
);

export const ReceiveSquare2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <ReceiveSquare2Linear />
    </SvgIcon>
);

export const ReceivedLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ReceivedLinear />
    </SvgIcon>
);

export const ReviewCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ReviewCustomLinear />
    </SvgIcon>
);

export const ScanBarcodeLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ScanBarcodeLinear />
    </SvgIcon>
);

export const SearchNormal1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <SearchNormal1Linear />
    </SvgIcon>
);

export const SearchNormalLinearIcon = (props) => (
    <SvgIcon {...props}>
        <SearchNormalLinear />
    </SvgIcon>
);

export const SendSqaure2LinearIcon = (props) => (
    <SvgIcon {...props}>
        <SendSqaure2Linear />
    </SvgIcon>
);

export const SendLinearIcon = (props) => (
    <SvgIcon {...props}>
        <SendLinear />
    </SvgIcon>
);

export const Setting4LinearIcon = (props) => (
    <SvgIcon {...props}>
        <Setting4Linear />
    </SvgIcon>
);

export const ShopLinearIcon = (props) => (
    <SvgIcon {...props}>
        <ShopLinear />
    </SvgIcon>
);

export const SliderHorizontal1LinearIcon = (props) => (
    <SvgIcon {...props}>
        <SliderHorizontal1Linear />
    </SvgIcon>
);

export const SliderHorizontalLinearIcon = (props) => (
    <SvgIcon {...props}>
        <SliderHorizontalLinear />
    </SvgIcon>
);

export const SortLinearIcon = (props) => (
    <SvgIcon {...props}>
        <SortLinear />
    </SvgIcon>
);

export const StacksstxLinearIcon = (props) => (
    <SvgIcon {...props}>
        <StacksstxLinear />
    </SvgIcon>
);

export const StoryLinearIcon = (props) => (
    <SvgIcon {...props}>
        <StoryLinear />
    </SvgIcon>
);

export const TickSquareCustomLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TickSquareCustomLinear />
    </SvgIcon>
);

export const TickSquareLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TickSquareLinear />
    </SvgIcon>
);

export const TimerLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TimerLinear />
    </SvgIcon>
);

export const TrashLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TrashLinear />
    </SvgIcon>
);
export const TrashErrorLinearIcon = (props) => (
    <SvgIcon {...props}>
        <TrashErrorLinear />
    </SvgIcon>
);

export const UserOctagonLinearIcon = (props) => (
    <SvgIcon {...props}>
        <UserOctagonLinear />
    </SvgIcon>
);

export const UserTagLinearIcon = (props) => (
    <SvgIcon {...props}>
        <UserTagLinear />
    </SvgIcon>
);
export const EmptyWalletBulkIcon = (props) => (
    <SvgIcon {...props}>
        <EmptyWalletBulk />
    </SvgIcon>
);
export const EmptyWalletTransparentBulkIcon = (props) => (
    // <SvgIcon {...props} sx={{ color: 'white' }}>
    <EmptyWalletTransparentBulk />
    // </SvgIcon>
);
export const ProfileCircleBulkIcon = (props) => (
    <ProfileCircleTransparentBulk />
);
export const HomeBulkIcon = (props) => <HomeBulk />;
export const HomeTranspBulkIcon = (props) => <HomeTranspBulk />;
